import React from "react";
import "./GuideProfile.css";
import "./GuideProfileSetting.css";
import {
  FaEnvelope, FaMapMarkerAlt, FaFileAlt, FaUniversity, FaMoneyBillWave,
  FaCoins, FaStar, FaBed, FaCalendarCheck
} from "react-icons/fa";

import hotel1 from "../assets/hotel1.png";
import NavUser from "../components/NavUser";

function HotelSetting() {
  return (
    <div>
      <NavUser />
      <div className="guider-profile-container">
        {/* Profile Card */}
        <div className="profile-card-flex">
          <div className="profile-left">
            <img src={hotel1} alt="Hotel" className="profile-avatar" />
            <div className="profile-details">
              <h2 className="profile-name">Cinnamon Grange</h2>
              <p className="profile-tagline">Speaks English, Spanish, Japanese</p>
              <p className="profile-tagline">Ella, Sri Lanka | Guide</p>
            </div>
          </div>

          <div className="profile-right">
            {/* You can add buttons or summary here */}
          </div>
        </div>

        {/* Two-column section */}
        <section className="guider-profile-body">
          <div className="guider-left-column">
            {/* Business Information */}
            <h3 className="section-title">Business Information</h3>
            <div className="info-item">
              <FaEnvelope className="info-icon" />
              <div className="info-text">
                <h4>Email</h4>
                <p>info@cinnamongrange.com</p>
              </div>
            </div>
            <div className="info-item">
              <FaMapMarkerAlt className="info-icon" />
              <div className="info-text">
                <h4>Location</h4>
                <p>12/5 Ocean Drive, Bentota, Kalutara</p>
              </div>
            </div>
            <div className="info-item">
              <FaFileAlt className="info-icon" />
              <div className="info-text">
                <h4>Business Reg. Doc</h4>
                <p>coastalcove_regcert.pdf</p>
              </div>
            </div>

            {/* Payment Information */}
            <h3 className="section-title">Payment Information</h3>
            <div className="info-item">
              <FaUniversity className="info-icon" />
              <div className="info-text">
                <h4>Bank Name</h4>
                <p>Bank of Ceylon</p>
              </div>
            </div>
            <div className="info-item">
              <FaMoneyBillWave className="info-icon" />
              <div className="info-text">
                <h4>Account Number</h4>
                <p>778901234567</p>
              </div>
            </div>
          </div>

          <div className="guider-right-column">
            <h3 className="section-title">Business Performance</h3>
            <div className="info-item">
              <FaBed className="info-icon" />
              <div className="info-text">
                <h4>Total Listings</h4>
                <p>5 Rooms (Standard, Deluxe, Suite, Family, Villa)</p>
              </div>
            </div>
            <div className="info-item">
              <FaCoins className="info-icon" />
              <div className="info-text">
                <h4>Coin Balance</h4>
                <p>120 Coins</p>
              </div>
            </div>
            <div className="info-item">
              <FaCalendarCheck className="info-icon" />
              <div className="info-text">
                <h4>Last Withdrawal</h4>
                <p>Rs. 15,000 on August 10, 2024</p>
              </div>
            </div>
            <div className="info-item">
              <FaStar className="info-icon" />
              <div className="info-text">
                <h4>Average Rating</h4>
                <p>4.8 (250 Reviews)</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default HotelSetting;
